import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website' }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, propName = 'name') => {
      let el = document.querySelector(`meta[${propName}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(propName, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', ogType, 'property');
    if (canonicalUrl) {
      setMeta('og:url', canonicalUrl, 'property');
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }

    setMeta('twitter:title', title, 'name');
    setMeta('twitter:description', description, 'name');
  }, [title, description, keywords, canonicalUrl, ogType]);

  return null;
}